import React, { Component } from "react";
import { Redirect } from 'react-router';
import ReCAPTCHA from "react-google-recaptcha";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn
  //MDBIcon,
  //MDBCard,
  //MDBCardBody,
  //MDBModal,
  //MDBModalBody,
  //MDBModalFooter
} from "mdbreact";
//import DocsLink from "./../components/docsLink";
import SectionContainer from "./../components/sectionContainer";
import axios from 'axios';
import logo1 from './login.png';

class FormsPage extends Component {
  /*
  state = {
    modal: false
  };
  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };
  */
    state = {
      contacts : [],  //activo  
      username: '',//activo
      clave: '',  //activo 
      message: '', 
      direccionURL : false,
      hablilitar : '',
      usuarioEnviado : ''//activo
    }

    onChange(e){
      this.setState({
          [e.target.name]:e.target.value
      })
    }

    //llamamos al a funcion tick
    tick() {
      //window.location.reload();
      //this.setState({ username : ''})
      console.log(this.state.username);
    }
    
  //metodo para enviar a la base de datos
  onSubmit = (e) =>{
    e.preventDefault(); 
    //console.log(e);
    //axios.post('http://remuneraciones.unsaac.edu.pe/verificarpassword/'+this.state.username+'/'+ this.state.clave+'',{
    axios.post('http://remuneraciones.unsaac.edu.pe:3001/verificarpassword/',{
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '[your API key----]'
        },
        body: JSON.stringify({
          usuario: this.state.username,
          clave: this.state.clave
        })
      })
      .then((response) => {
        this.setState({ contacts : response.data});
      })
      .catch(error =>{})  
        
        const dato = this.state.username;
        //this.setState({ usuarioEnviado : this.state.username})
        this.setState({ usuarioEnviado : dato})
        this.setState({ username : ''})
        this.setState({ clave : ''})
  } 
  
  //Metodo render
  render() {
    if(this.state.contacts.length>0){   
      console.log('la autorizacion sera...'+this.state.contacts.autorizacion);
      console.log(this.state.contacts);    
      return <Redirect to={{ pathname: '/tables/datatableNuevo', state: { datos: this.state.contacts}}}/>
      } else {                                
      }  
            
    return (
      <MDBContainer className="mt-4">
        <SectionContainer header="Boleta de pago virtual - UNSAAC" noBorder>
          <MDBRow>
	    <MDBCol md="2">
	    </MDBCol>
            <MDBCol md="4">
              <SectionContainer>
                <form onSubmit = {this.onSubmit}>
                  <p className="h5 text-center mb-4">Inicio de sesion</p>
                  <div className="grey-text">
                    <MDBInput
                      label="Ingrese su nro. de DNI"
                      icon="envelope"
                      group                      
                      validate
                      error="wrong"
                      success="right"
                      value = {this.state.username} 
                      onChange={this.onChange.bind(this)}
                      name="username" 
                      id="username" 
                      type="text"
                    />
                    <MDBInput 
                      label="Ingrese su contraseñaa" 
                      icon="lock" 
                      group                     
                      validate 
                      error="wrong"
                      success="right"
                      value = {this.state.clave} 
                      onChange={this.onChange.bind(this)}
                      name="clave" 
                      id="clave" 
                      type="password"                      
                    />
                  </div>                  
                  <div className="text-center">
                    {/* <MDBBtn onClick={this.acceder.bind(this)}>Acceder</MDBBtn> */}
                    <MDBBtn type="submit">Acceder</MDBBtn>
                  </div>
                </form>
              </SectionContainer>
            </MDBCol>
            <MDBCol md="6">
              <div>
                <img src={logo1} width="300" height="300" />
              </div>
            </MDBCol>
          </MDBRow>
        </SectionContainer>

      </MDBContainer>
    );
  }
}

export default FormsPage;
